<template>
  <div>
    <v-row class="justify-center">
      <v-col cols="12">
        <v-card color="blue darken-1" hover dark class="pa-4">
          <v-card-title class="text-break">
            کاربر گرام جهت استعلام آنلاین مدرک لطفا کد پیگیری مدرک را وارد
            نمایید
          </v-card-title>
          <v-form @submit.prevent="getWithQuery">
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field
                  label="کد پیگیری"
                  filled
                  rounded
                  v-model="id"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-btn
                  :loading="isLoading"
                  :disabled="isLoading"
                  @click="getWithQuery"
                  class="mx-auto rounded-pill"
                  height="55px"
                  block
                  color="blue darken-4"
                  width="200px"
                  >{{ $_t("attribute.inquiry") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="alert" justify="center">
      <v-col cols="6">
        <v-alert dark width="100%" :type="alert.type" :color="alert.color">
          <div class="font-weight-bold">
            {{ alert.text }}
          </div>
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import message from "@/tools/Message";

export default {
  name: "GetCertWithQuery",
  data: () => ({
    id: "",
    alert: null,
  }),
  computed: {
    ...mapGetters({
      isLoading: "loading/is_loading",
    }),
  },
  methods: {
    async getWithQuery() {
      if (!this.id) return message.error("لطفا کد پیگیری را وارد نمایید");
      const { data } = await this.$actions.getCertWithQuery(this.id);
      if (data.state === "Done")
        this.alert = {
          type: "success",
          color: "success",
          text: `کاربر گرامی،با عنایت به مدرک گواهی نامه استعلامی شما،به اطلاع میرساند.کد ارسالی به شماره ${
            data.queryId
          } بنام ${data.fullName} به کد ملی ${
            data.nationalId
          } در سطح ${this.$_t(`attribute.${data.level}`)} در رشته ${
            data.levelType
          }‌ توسط مهرآوران دانش پژوهان البرز صادر گردیده ومورد تایید این موسسه میباشد.`,
        };
      if (data.state === "NoCertificate")
        this.alert = {
          type: "warning",
          color: "warning",
          text: "کد ارسالی معتبر نیست و مدرکی ثبت نشده.",
        };
      if (data.state === "Ban")
        this.alert = {
          type: "error",
          color: "red",
          text: "کاربر گرامی  به دلیل عدم پرداخت هزینه مدرک شما از طرف مدیریت سایت باطل شده است.",
        };
      else this.alet = null;
    },
  },
};
</script>

<style scoped></style>
